module.exports = __webpack_public_path__ + "img/zz.c5345d58.png";